import { Base } from './base';

export class ParkingPoint extends Base {
    ParkingPointID?: string;
    ParkingID?: number;
    Latitude?: number;
    Longitude?: number;
    Position?: number;
}

export interface IParkingPoint {
    parkingPointID: string;
    groupID: number;
    position: number;
    latitude: number;
    longitude: number;
}
